const diyLoanDetailsEventCategory = "DIY_CR";

export const diyLoanStatusInput = {
    eventCategory: diyLoanDetailsEventCategory,
    event: "Loan_status_input",
    eventAction: "Loan status input"
};

export const diyLoanStatusPageViewed = {
    eventCategory: diyLoanDetailsEventCategory,
    event: "Loan_detail_page viewed",
    eventAction: "Loan detail page viewed"
};
